import { useState, useCallback } from 'react';
import { Alert, Button, Divider, Link } from '@heroui/react';
import { Uniformly } from '@livefree/uniformly';
import { Animate, useAutoFocus, StyledTextField, StyledButton } from '@/shared/components';
import { RoutePaths } from '@/routing/RoutePaths';
import { keyPressedHandler } from '@livefree/react-ui';
import { useLogin, useLoginInfo } from '@/features/login';
import { reactive } from '@/core/reactive/reactive';

export const LoginForm = reactive.component(
  ({ services, monitors, form, dispatch }) => {
    const info = useLoginInfo();
    const { login } = useLogin(services, dispatch);
    useAutoFocus('username');

    const enabled = form.username && form.password && info.isReady;

    const handleLogin = useCallback(() => {
      if (enabled) {
        login(form.username, form.password);
      }
    }, [enabled, form.username, form.password, login]);

    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => setIsVisible(!isVisible);

    return (
      <Animate id="login" className="w-full">
        {form.message && <Alert color="danger" description={form.message} />}
        <Uniformly
          onChange={form => dispatch({ type: 'info', payload: form.data })}
          className="flex flex-col gap-4"
          throttle={100}
        >
          <StyledTextField label="Username" id="username" name="username" />

          <StyledTextField
            endContent={
              <button type="button" onClick={toggleVisibility}>
                {isVisible ? (
                  <i className="text-lg ri-eye-line" />
                ) : (
                  <i className="text-lg ri-eye-off-line" />
                )}
              </button>
            }
            label="Password"
            name="password"
            type={isVisible ? 'text' : 'password'}
            onKeyDown={keyPressedHandler('enter', handleLogin)}
          />

          <div className="flex items-center justify-end px-1">
            {/*
            <Checkbox
              classNames={{
                wrapper: 'before:border-foreground/50',
              }}
              name="remember"
              size="sm"
            >
              Remember me
            </Checkbox>
            */}
            <Link
              className="text-foreground/50"
              href={RoutePaths().login.forgotPassword()}
              size="sm"
            >
              Forgot password?
            </Link>
          </div>
          <StyledButton
            isDisabled={!enabled}
            isLoading={monitors.login.executing}
            onPress={handleLogin}
          >
            Log in
          </StyledButton>
        </Uniformly>
        <div className="flex items-center gap-4 py-4">
          <Divider className="flex-1" />
          <p className="shrink-0 text-tiny text-default-500">OR</p>
          <Divider className="flex-1" />
        </div>
        <form action="/best-buy/login" method="POST">
          <Button
            type="submit"
            className="bg-[#0a4abf] text-white"
            fullWidth
            startContent={
              <i className="text-[#f6eb16] text-lg ri-price-tag-fill -rotate-90 scale-x-80" />
            }
          >
            <span>
              Log in with <span className="font-black">BEST BUY</span>
            </span>
          </Button>
        </form>
      </Animate>
    );
  },
  {
    name: 'LoginForm',
    monitors: services => [services.login.login],
  },
);
